import type { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getOpportunityLastSelectedStateListData,
  getOpportunityLastSelectedStateData,
} from './mockData'
import type { IOpportunityLastSelectedState } from '~/types/opportunity/models'

interface GetOpportunityLastSelectedStateListDataResponse {
  data: IOpportunityLastSelectedState[]
}

async function getOpportunityLastSelectedListData(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetOpportunityLastSelectedStateListDataResponse = {
    data: await getOpportunityLastSelectedStateListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetOpportunityLastSelectedStateResponse {
  data: IOpportunityLastSelectedState
}

async function getOpportunityLastSelectedState(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  const responseBody: GetOpportunityLastSelectedStateResponse = {
    data: await getOpportunityLastSelectedStateData(id),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postOpportunityLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(
    req,
    res,
    ctx,
    getOpportunityLastSelectedStateListData
  )
}

const patchOpportunityLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(
    req,
    res,
    ctx,
    getOpportunityLastSelectedStateListData
  )
}

const deleteOpportunityLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getOpportunityLastSelectedStateListData
  )
}

export const handlers = [
  {
    method: 'get',
    path: '/api/opportunitylastselectedstates',
    handler: getOpportunityLastSelectedListData,
  },
  {
    method: 'get',
    path: '/api/opportunitylastselectedstates/:id',
    handler: getOpportunityLastSelectedState,
  },
  {
    method: 'post',
    path: '/api/opportunitylastselectedstates',
    handler: postOpportunityLastSelectedState,
  },
  {
    method: 'patch',
    path: '/api/opportunitylastselectedstates/:id',
    handler: patchOpportunityLastSelectedState,
  },
  {
    method: 'delete',
    path: '/api/opportunitylastselectedstates/:id',
    handler: deleteOpportunityLastSelectedState,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
